module.exports = __webpack_public_path__ + "img/form-lower-title-tablet.501c9ea5.png";